import { LoginUser, OperatorLogged } from 'app/interfaces/User';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export interface ImpersonationOrigin {
  loginUser: LoginUser;
  operatorLogged: OperatorLogged | undefined;
}

interface ImpersonationStore {
  origin: ImpersonationOrigin | undefined;
  expiredNotice: boolean;
}

interface ImpersonationActions {
  setOrigin: (origin: ImpersonationOrigin | undefined) => void;
  clearOrigin: () => void;
  setExpiredNotice: (value: boolean) => void;
}

export const useImpersonationStore = create(
  persist<ImpersonationStore & ImpersonationActions>(
    set => ({
      origin: undefined,
      expiredNotice: false,
      setOrigin: origin => {
        set({ origin });
      },
      clearOrigin: () => {
        set({ origin: undefined });
      },
      setExpiredNotice: value => {
        set({ expiredNotice: value });
      },
    }),
    {
      name: 'impersonation-storage',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
